import type { ReceiptFailureCode } from './types.ts'

/** The server never sends raw failure text any more - only a stable [ReceiptFailureCode] - so a
 * translated, friendly message is the only thing this screen can ever show for a failed scan. */
export function failureMessageKey(code: ReceiptFailureCode | undefined): string {
  switch (code) {
    case 'AI_UNAVAILABLE':
      return 'receiptScan.failure.AI_UNAVAILABLE'
    case 'EXTRACTION_FAILED':
      return 'receiptScan.failure.EXTRACTION_FAILED'
    default:
      return 'receiptScan.failure.UNKNOWN'
  }
}
